import React, {
  Component
} from 'react';
import {
  Container,
  Grid,
  Header,
  Icon,
  Segment
} from 'semantic-ui-react';
import {
  push,
  replace
} from 'react-router-redux';
import {
  connect
} from 'react-redux';
import authenticationActions from './../../store/actions/authenticationActions';
import feathersConnect from './../../providers/feathersConnect';

class SignOutView extends Component {

  constructor (props) {
    super(props);
  }

  componentDidMount () {
    this.props.feathers.logout()
      .then(response => {
        this.props.logOut();
        this.props.navigate('/ingresar');
      })
      .catch(error => {
        console.error(error);
      });
  }

  static mapStateToProps (state) {
    return {
      authentication: state.authentication.toJS({ deep: true })
    };
  }

  static mapDispatchToProps (dispatch) {
    return {
      navigate: (path) => {
        dispatch(push(path));
      },
      logOut: () => {
        dispatch(authenticationActions.auth.logOut());
      }
    };
  }

  render () {
    return (
      <Container style={{ padding: 16 }}>
        <Grid doubling columns={2} centered>
          <Grid.Column>
            <Segment textAlign="center" color="red">
              <Header as="h2">
                CERRANDO SESION
              </Header>
            </Segment>
          </Grid.Column>
        </Grid>
      </Container>
    );
  }
}

export default feathersConnect(
  connect(
    SignOutView.mapStateToProps,
    SignOutView.mapDispatchToProps
  )(SignOutView)
);



// WEBPACK FOOTER //
// ./client/components/pages/SignOutView.js